<div class="themed-dialog interests-dialog">
  <div class="interests-dialog__introduction" *ngIf="!showForm">
    <div class="themed-dialog__header">
      <h3 class="themed-dialog__title" tabindex="0">{{ 'general.salute' | translate }} {{ userName }}</h3>

      <button *ngIf="!interests.mandatory" mat-flat-button class="only-icon" mat-dialog-close [attr.aria-label]="'general.close' | translate">
        <span class="odilo-icon" aria-hidden="true">close</span>
      </button>
    </div>

    <div class="themed-dialog__content">
      <div
        class="themed-dialog__content__text"
        tabindex="0"
        [innerHTML]="'user.interests.description' | translate"></div>
    </div>

    <div mat-dialog-actions class="themed-dialog__actions">
      <div *ngIf="!interests.mandatory" class="themed-dialog__actions__left">
        <button class="link" mat-flat-button (click)="close(true)">{{ 'general.later' | translate }}</button>
        <button class="link" mat-flat-button (click)="close(false)">{{ 'general.never' | translate }}</button>
      </div>

      <div class="themed-dialog__actions__right">
        <button class="btn-icon-text accent-bg" mat-flat-button (click)="startForm()">
          <span class="text-mr">{{ 'general.start' | translate }}</span>
          <span class="odilo-icon">navigate_next</span>
        </button>
      </div>
    </div>
  </div>

  <div class="interests-dialog__form" *ngIf="showForm">
    <div class="themed-dialog__header">
      <button
        *ngIf="!interests.mandatory"
        mat-flat-button
        class="only-icon"
        mat-dialog-close
        (click)="close(true)"
        [attr.aria-label]="'general.close' | translate">
        <span class="odilo-icon" aria-hidden="true">close</span>
      </button>
    </div>

    <mat-horizontal-stepper labelPosition="bottom" linear #stepper>
      <mat-step *ngFor="let question of questions; let i = index" [stepControl]="formGroups[i]">
        <form [formGroup]="formGroups[i]">
          <p class="mat-stepper__label">{{ 'general.step' | translate }} {{ i + 1 }}</p>

          <div class="mat-stepper__content">
            <h2 class="interests-dialog__form__title">{{ question.title }}</h2>
            <p class="interests-dialog__form__text">{{ question.description }}</p>

            <ng-container *ngIf="question.type === 'RADIOBUTTON'">
              <app-radio-question
                [question]="question"
                [showEveryLevelAtOnce]="false"
                (selected)="onSelected(i, question.id, $event)"></app-radio-question>
            </ng-container>

            <ng-container *ngIf="question.type === 'TAGS'">
              <app-tag-question
                [question]="question"
                (selected)="onSelected(i, question.id, $event)"></app-tag-question>
            </ng-container>
          </div>

          <div class="mat-stepper__actions">
            <button
              *ngIf="stepper.selectedIndex !== 0"
              mat-flat-button
              class="btn-icon-text back-btn"
              matStepperPrevious>
              <span class="odilo-icon">navigate_before</span>
              <span class="text">{{ 'general.back' | translate }}</span>
            </button>

            <button *ngIf="!interests.mandatory" mat-flat-button class="btn-icon-text cancel-btn" (click)="close(true)" mat-dialog-close>
              <span class="text">{{ 'general.cancel' | translate }}</span>
            </button>

            <button
              mat-flat-button
              class="btn-icon-text accent-bg continue-btn"
              matStepperNext
              [disabled]="!formGroups[i].valid">
              <span class="text-mr">{{ 'general.continue' | translate }}</span>
              <span class="odilo-icon">navigate_next</span>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <h2 class="interests-dialog__form__title">{{ 'general.done' | translate }}!</h2>
        <p class="interests-dialog__form__text">{{ 'user.interests.done' | translate }}</p>

        <div class="mat-stepper__actions">
          <button mat-flat-button class="btn-icon-text back-btn" matStepperPrevious>
            <span class="odilo-icon">navigate_before</span>
            <span class="text">{{ 'general.back' | translate }}</span>
          </button>

          <button
            mat-flat-button
            class="btn-icon-text accent-bg continue-btn"
            matStepperNext
            (click)="submit()"
            [disabled]="waiting">
            <span class="text-mr">{{ 'general.saveChanges' | translate }}</span>
            <span class="odilo-icon">navigate_next</span>
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
